/*
 * ============================================================
 * SAV_ERP — Smart Account Vision Enterprise Resource Planning
 * Copyright (c) 2026 Hatem Mohamed Abdalla.
 * All rights reserved.
 *
 * This file is part of a proprietary software product owned
 * solely by Hatem Mohamed Abdalla (UAE, +971 50 390 9781).
 * Copying, redistribution, modification, reverse engineering
 * or reuse in any form without prior written consent of the
 * copyright owner is strictly prohibited and will be
 * prosecuted under UAE Federal Law No. 38/2021 on Copyright
 * and applicable international treaties.
 *
 * Fingerprint: SAV-ERP-HMA-2026-#a7f3d0
 * ============================================================
 */
const isEmailLike = (value = '') => /.+@.+\..+/.test(String(value).trim());

export const validateLoginPayload = ({ loginType = 'company', formData = {}, language = 'ar' }) => {
  const email = String(formData.email || '').trim();
  const password = String(formData.password || '');
  const companyCode = String(formData.company_code || '').trim().toUpperCase();

  if (!email) {
    return language === 'ar' ? 'البريد الإلكتروني مطلوب' : 'Email is required';
  }
  if (!isEmailLike(email)) {
    return language === 'ar' ? 'البريد الإلكتروني غير صالح' : 'Please enter a valid email address';
  }
  if (!password) {
    return language === 'ar' ? 'كلمة المرور مطلوبة' : 'Password is required';
  }
  if (password.length < 6) {
    return language === 'ar' ? 'كلمة المرور يجب أن تكون 6 أحرف على الأقل' : 'Password must be at least 6 characters';
  }
  if (loginType === 'company' && !companyCode) {
    return language === 'ar' ? 'رمز الشركة مطلوب' : 'Company code is required';
  }

  return '';
};

export const normalizeLoginPayload = ({ loginType = 'company', formData = {} }) => {
  const payload = {
    email: String(formData.email || '').trim(),
    password: String(formData.password || ''),
  };

  if (loginType === 'company') {
    payload.company_code = String(formData.company_code || '').trim().toUpperCase();
  }

  return payload;
};
